/*
 * View for the footer
 */

define(["marionette", "modules/footer/template/footerTemplate.html"], function (
  Marionette,
  FooterTemplate,
) {
  var FooterView = {};

  FooterView.footerView = Marionette.ItemView.extend({
    template: FooterTemplate,
    className: "footer",
  });

  return FooterView;
});
